<template>
  <div id="main-layout">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <van-tabbar
      v-model="active"
      :fixed="true"
      :border="true"
      active-color="#6366f1"
      inactive-color="#999"
      :safe-area-inset-bottom="true"
      route
    >
      <van-tabbar-item to="/resources" icon="orders-o">资源</van-tabbar-item>
      <van-tabbar-item to="/sales" icon="balance-list-o">流水</van-tabbar-item>
      <van-tabbar-item to="/profile" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  data() {
    return { active: 0 };
  },
  watch: {
    $route: {
      handler(to) {
        if (to.meta.tab !== undefined) this.active = to.meta.tab;
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
#main-layout {
  padding-bottom: 50px; /* tabbar height */
  min-height: 100vh;
  background: #f5f7fa;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
